//
//
//
//
//
//

export default {
    middleware: 'appData'
}
